import * as Sentry from "@sentry/react";
import { useEffect, useRef } from "react";

import { AssetErrorVideoFragment } from "../../graphql/graphql";

interface AssetErrorVideosProps {
  videos: AssetErrorVideoFragment[];
  playAllButtonClicked: boolean;
}

const AssetErrorVideo = ({
  video,
  playAllButtonClicked,
}: {
  video: AssetErrorVideoFragment;
  playAllButtonClicked: boolean;
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (playAllButtonClicked) {
      videoRef.current
        ?.play()
        .catch((error: unknown) => Sentry.captureException(error));
    }
  }, [playAllButtonClicked]);

  return (
    <div
      key={video.id}
      style={{
        flex: 1,
        borderRadius: "20px",
        overflow: "hidden",
        maxWidth: "1000px",
        width: "100%",
      }}
    >
      <div
        style={{
          position: "relative",
          borderRadius: "20px",
          overflow: "hidden",
          width: "100%",
          paddingTop: "56.25%",
        }}
      >
        <video
          ref={videoRef}
          controls
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={video.videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

const AssetErrorVideos = ({
  videos,
  playAllButtonClicked,
}: AssetErrorVideosProps) => {
  if (videos.length === 0) {
    return <h2>No videos available</h2>;
  }

  const sortedVideos = [...videos].sort((a, b) =>
    a.cameraName.localeCompare(b.cameraName),
  );

  return (
    <div
      style={{
        display: "flex",
        gap: "20px",
        width: "100%",
        justifyContent: "center",
      }}
    >
      {sortedVideos.map((video) => (
        <AssetErrorVideo
          video={video}
          playAllButtonClicked={playAllButtonClicked}
        />
      ))}
    </div>
  );
};

export default AssetErrorVideos;
